function IndexPage() {
  return (
    <div>
      <h2>Welcome to Messages!</h2>
      <p>
        You can sign in using any of credentials below and start sending
        messages between users.
      </p>
      <p>Usernames:</p>
      <ul>
        <li>Joe</li>
        <li>Bob</li>
        <li>Foe</li>
      </ul>
      <p>
        Passwords are always <b>1234</b>
      </p>
      <p>
        After signing in, navigate to <b>chats</b>. Here you will see user which
        you sent or received messages from. Choose any of existing chats or
        press <b>New message</b> to start a new one.
      </p>
      <p>
        It's recommended to open this web app using two different browsers or
        use incognito mode and login using two user accounts. That way you can
        send and receive messages in real time.
      </p>
    </div>
  );
}

export default IndexPage;
